import React, { Component } from 'react';
import { styled } from '@compiled/react';
import clamp from 'lodash/clamp';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import { DEFAULT_LIST_WIDTH } from '../../../../../model/table';
import { CHART_OVERLAY_Z_INDEX } from '../../../../../styles/z-index';
import type { Position } from '../../../common/components/drag-observer/types.tsx';
import withDragObserver from '../../../common/components/drag-observer/view.tsx';

type Props = {
	width: number;
	onResize: (width: number) => void;
	onEndResize: (width: number) => void;
};

// eslint-disable-next-line jira/react/no-class-components
class ListResizer extends Component<Props> {
	onDrag = (from: Position, to: Position, start: Position) => {
		const diffX = this.calculateListWidth(to.x - start.x);
		this.onResize(diffX);
	};

	onStartDrag = () => {
		this.width = this.props.width;
	};

	onEndDrag = () => {
		const { onEndResize } = this.props;
		onEndResize(this.width);
	};

	onResize(diffX: number) {
		const { onResize } = this.props;
		onResize(diffX);
	}

	calculateListWidth(diffX: number) {
		const newWidth = Math.round(this.width + diffX);
		return clamp(newWidth, DEFAULT_LIST_WIDTH, Infinity);
	}

	// @ts-expect-error - TS2564 - Property 'width' has no initializer and is not definitely assigned in the constructor.
	width: number;

	render() {
		return (
			<ResizeHandlerDrag
				onDrag={this.onDrag}
				onDragStart={this.onStartDrag}
				onDragEnd={this.onEndDrag}
				isDisabled={false}
				onMouseDown={undefined}
				onClick={undefined}
			/>
		);
	}
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ResizeHandler = styled.div({
	position: 'absolute',
	right: token('space.negative.050', '-4px'),
	top: 0,
	width: token('space.100', '8px'),
	height: '100%',
	cursor: 'ew-resize',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: CHART_OVERLAY_Z_INDEX,
	opacity: 0,
	transition: 'opacity 0.1s ease',
	'&::after': {
		pointerEvents: 'none',
		position: 'absolute',
		right: token('space.025', '2px'),
		top: 0,
		width: token('space.025', '2px'),
		height: '100%',
		display: 'block',
		content: "' '",
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		background: token('color.background.accent.blue.subtler', colors.B200),
	},
	'&:hover': {
		opacity: 1,
	},
});

const ResizeHandlerDrag = withDragObserver(ResizeHandler);

export default ComponentWithAnalytics('list', {
	onEndResize: 'resized',
})(ListResizer);
